export const CHECKOUT_URL = 'https://sos-veraz.impultienda.ar/checkout'

export const PRECIO = '$16.990'
export const PRECIO_LARGO = 'ARS $16.990'
export const PRECIO_ANTERIOR = 'ARS $84.950'

export const MOCKUP = 'https://cdn.magicpatterns.com/uploads/msCXHbDHJUihZa2J8DNyUc/mockup.png'
export const MOCKUP_ALT =
  'Manual SOS VERAZ — Protocolo de Salida Rápida junto al diagnóstico en 15 minutos, el pack de plantillas de reclamo y el tracker de 30 días'

export const SOPORTE_EMAIL = 'soporte@creativodigital.shop'
export const INSTAGRAM_USER = '@creativodigitalstudio'
export const INSTAGRAM_URL = 'https://www.instagram.com/creativodigitalstudio'
export const WEB_LABEL = 'www.creativodigital.shop'
export const WEB_URL = 'https://www.creativodigital.shop'

export const CTA_PRINCIPAL = 'Quiero empezar a limpiar mi historial'
export const CTA_SECUNDARIO = 'Quiero recuperar mi nombre financiero'

export const heroBullets: string[] = [
  'Manual práctico, paso a paso',
  'Procedimientos según Ley 25.326',
  'Sin lenguaje técnico',
  'Acceso digital inmediato',
]

export type ProblemItem = {
  title: string
  text: string
}

export const problems: ProblemItem[] = [
  {
    title: 'Te rechazaron un crédito',
    text: 'Pediste financiación, la respuesta fue no y nadie te dijo qué dato la frenó.',
  },
  {
    title: 'No podés acceder a cuotas',
    text: 'Querés financiar una compra y siempre aparece el mismo bloqueo.',
  },
  {
    title: 'Ya pagaste y sigue apareciendo',
    text: 'Cancelaste la deuda y tu informe la muestra como si nada hubiera cambiado.',
  },
  {
    title: 'Una deuda antigua sigue informada',
    text: 'Una situación de hace años continúa figurando y arrastra todo tu historial.',
  },
  {
    title: 'Una deuda que no reconocés',
    text: 'Aparece un dato a tu nombre que nunca generaste y nadie te lo explica.',
  },
  {
    title: 'Datos con errores o desactualizados',
    text: 'Montos, fechas o entidades mal informadas que quedaron ahí sin reclamo.',
  },
]

export type Etapa = {
  title: string
  text: string
}

export const etapas: Etapa[] = [
  {
    title: 'Diagnóstico Real',
    text: 'Cómo pedir y leer tu informe: qué figura, quién lo informó y desde cuándo.',
  },
  {
    title: 'Semáforo de Situaciones',
    text: 'Qué significa cada situación informada y cuánto pesa en tu historial.',
  },
  {
    title: 'Deuda Cancelada',
    text: 'Qué corresponde hacer si ya pagaste y el dato sigue desactualizado.',
  },
  {
    title: 'El Límite de los 5 Años',
    text: 'Los plazos de conservación de datos según la Ley 25.326 y cómo invocarlos.',
  },
  {
    title: 'Deudas Fantasmas',
    text: 'Cómo actuar frente a información que no reconocés, con respaldo documental.',
  },
  {
    title: 'Protocolo de Re-Inserción',
    text: 'Cómo ordenar tu perfil para volver a ser evaluado por las entidades.',
  },
]

export type Step = {
  number: string
  title: string
  text: string
}

export const steps: Step[] = [
  {
    number: '1',
    title: 'Entendé',
    text: 'Pedís tu informe y ves qué figura realmente: entidad, monto, fecha y situación.',
  },
  {
    number: '2',
    title: 'Clasificá',
    text: 'Con el semáforo ubicás tu caso: deuda cancelada, antigua, no reconocida o mal cargada.',
  },
  {
    number: '3',
    title: 'Accioná',
    text: 'Seguís el procedimiento que corresponde, con las plantillas y los plazos de la ley.',
  },
]

export type IncludedItem = {
  tag: string
  title: string
  description: string
}

export const mainProduct = {
  tag: 'Manual principal',
  title: 'SOS VERAZ — Protocolo de Salida Rápida',
  description: 'Las 6 etapas completas, en criollo, con el procedimiento de cada tipo de caso.',
}

export const bonos: IncludedItem[] = [
  {
    tag: 'Bono 1',
    title: 'Diagnóstico Veraz en 15 Minutos',
    description: 'Guía express para pedir tu informe y leer los puntos clave sin perderte.',
  },
  {
    tag: 'Bono 2',
    title: 'Pack de Plantillas de Reclamo Veraz',
    description:
      'Modelos de nota para pedir rectificación, actualización o supresión de datos, listos para completar.',
  },
  {
    tag: 'Bono 3',
    title: 'Tracker 30 Días Nombre Limpio',
    description: 'Planilla para seguir cada gestión: qué presentaste, cuándo y qué te respondieron.',
  },
]

export const noEs: string[] = [
  'No borra deudas vigentes ni promete resultados garantizados.',
  'No es un trámite exprés: son gestiones formales con plazos reales.',
  'No reemplaza el asesoramiento legal en casos que lleguen a instancia judicial.',
]

export type Faq = {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Esto me garantiza que salga del Veraz?',
    a: 'No, y desconfiá de quien lo prometa. El manual te enseña a entender qué figura a tu nombre y a ejecutar los procedimientos previstos por la Ley 25.326 para pedir la rectificación, actualización o supresión de datos cuando legalmente corresponde.',
  },
  {
    q: 'Ya pagué y sigue figurando. ¿Qué hago?',
    a: 'Es uno de los casos más frecuentes y tiene una etapa entera dedicada: cómo reunir el respaldo del pago y cómo presentar el pedido de actualización ante quien informó el dato.',
  },
  {
    q: '¿Sirve si la deuda es real y no la pagué?',
    a: 'Sí, para entender tu situación con precisión: qué está informado, desde cuándo y qué plazos corren. Si la deuda es vigente y exigible, el material no propone hacerla desaparecer.',
  },
  {
    q: '¿Qué es el límite de los 5 años?',
    a: 'La normativa de protección de datos fija plazos máximos de conservación de la información crediticia. Vas a ver cómo se cuentan y cómo solicitar la supresión cuando el dato ya no debería seguir informado.',
  },
  {
    q: '¿Necesito un abogado o un gestor?',
    a: 'Está pensado para que hagas las gestiones por tu cuenta con las plantillas incluidas. Si tu caso requiere una instancia judicial, te indicamos cuándo conviene asesorarte.',
  },
  {
    q: '¿Lo recibo al instante?',
    a: 'Sí. Apenas se confirma el pago accedés al manual y a los tres bonos, sin esperas.',
  },
]
